export const GetStarted = () => <div>Hello, World!</div>;
